import type { ReactNode } from 'react'
import { Icon } from './Icon'

export interface EmptyStateProps {
  icon: string
  eyebrow: ReactNode
  title: ReactNode
  action?: ReactNode
}

// A placeholder is a bordered block, not an illustration. Every unbuilt route renders this
// with what it will be and when. Vendored from the Admin Console unchanged, including the
// class names, so both consoles show the same thing for the same reason.
export function EmptyState({ icon, eyebrow, title, action }: EmptyStateProps) {
  return (
    <div className="empty-state">
      <div className="icon">
        <Icon name={icon} size={28} />
      </div>
      <div className="eyebrow">{eyebrow}</div>
      <div className="title">{title}</div>
      {action}
    </div>
  )
}
